import React from "react"
import { HomeQuickLinksContainer, HighlightedLink, HeroImg } from "./style"
import { ReactComponent as Arrow } from "images/icons/arrow-right.svg"
import { ReactComponent as Alert } from "images/icons/alert.svg"

const HomeQuickLinks = ({ data }) => {
  return (
    <HomeQuickLinksContainer>
      {data.homequicklinks.map((item, index) => {
        return (
          <li key={index}>
            <HighlightedLink
              color={item.page.pageSettings.pageTheme}
              to={item.page.link}
            >
              <span>{item.page.title}</span>
              <Arrow />
            </HighlightedLink>
            {item.description && (
              <p>
                {" "}
                <Alert /> {item.description}
              </p>
            )}
          </li>
        )
      })}
      <HeroImg>
        <img src={data.homeheader.headerImage.sourceUrl} />
      </HeroImg>
    </HomeQuickLinksContainer>
  )
}

export default HomeQuickLinks
